import React from "react";

const iconProps = {
  width: 14,
  height: 14,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

export function StorefrontGeneralTabIcon() {
  return (
    <svg {...iconProps}>
      <path
        d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1v-9.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontBrandingTabIcon() {
  return (
    <svg {...iconProps}>
      <path
        d="M5 19 19 5M7 5h12v12M5 7v12h12"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontHoursTabIcon() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 7v5l3.5 2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontOperationsTabIcon() {
  return (
    <svg {...iconProps}>
      <path
        d="M12 8.2a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6ZM12 3v3M12 18v3M4.2 7.5l2.6 1.5M17.2 15l2.6 1.5M19.8 7.5 17.2 9M6.8 15l-2.6 1.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontQrTabIcon() {
  return (
    <svg {...iconProps}>
      <path
        d="M5 5h5v5H5V5ZM14 5h5v5h-5V5ZM5 14h5v5H5v-5ZM14 14h2v2h-2v-2ZM17 17h2v2h-2v-2ZM19 14h-2M14 19v-2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontCustomerIcon() {
  return (
    <svg width="46" height="50" viewBox="0 0 46 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36 40V36.6667C36 34.8986 35.3152 33.2029 34.0962 31.9526C32.8772 30.7024 31.2239 30 29.5 30H16.5C14.7761 30 13.1228 30.7024 11.9038 31.9526C10.6848 33.2029 10 34.8986 10 36.6667V40M29.5 16.6667C29.5 20.3486 26.5899 23.3333 23 23.3333C19.4101 23.3333 16.5 20.3486 16.5 16.6667C16.5 12.9848 19.4101 10 23 10C26.5899 10 29.5 12.9848 29.5 16.6667Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StorefrontDriverIcon() {
  return (
    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.3371 10C37.8549 10 38.3516 10.2057 38.7178 10.5719C39.084 10.938 39.2897 11.4347 39.2897 11.9525V13.905H49.053V25.62H45.1106L50.4725 40.3496C50.8566 41.341 51.0343 42.4003 50.9946 43.4627C50.9549 44.525 50.6987 45.5681 50.2416 46.528C49.7846 47.4879 49.1365 48.3444 48.3368 49.0451C47.5372 49.7457 46.6029 50.2757 45.5912 50.6026C44.5795 50.9295 43.5117 51.0465 42.4532 50.9463C41.3947 50.8461 40.3679 50.5308 39.4355 50.0199C38.5031 49.5089 37.6849 48.813 37.031 47.9747C36.377 47.1365 35.9011 46.1736 35.6324 45.145H27.3278C26.884 46.8586 25.8715 48.3708 24.456 49.4339C23.0406 50.497 21.306 51.048 19.5365 50.9967C17.767 50.9454 16.0673 50.2949 14.7158 49.1517C13.3642 48.0084 12.441 46.4401 12.0971 44.7037C11.4643 44.3732 10.9343 43.8755 10.5645 43.2649C10.1948 42.6542 9.99954 41.9538 10 41.24V21.715C10 21.1972 10.2057 20.7005 10.5719 20.3344C10.9381 19.9682 11.4348 19.7625 11.9526 19.7625H25.6212C26.1391 19.7625 26.6357 19.9682 27.0019 20.3344C27.3681 20.7005 27.5738 21.1972 27.5738 21.715V31.4775C27.5738 31.9953 27.7796 32.4919 28.1457 32.8581C28.5119 33.2243 29.0086 33.43 29.5265 33.43H33.4318C33.9496 33.43 34.4463 33.2243 34.8125 32.8581C35.1787 32.4919 35.3844 31.9953 35.3844 31.4775V13.905H29.5265V10H37.3371ZM19.7632 39.2875C18.7275 39.2875 17.7342 39.6989 17.0018 40.4312C16.2694 41.1636 15.8579 42.1568 15.8579 43.1925C15.8579 44.2281 16.2694 45.2214 17.0018 45.9537C17.7342 46.6861 18.7275 47.0975 19.7632 47.0975C20.799 47.0975 21.7923 46.6861 22.5247 45.9537C23.2571 45.2214 23.6685 44.2281 23.6685 43.1925C23.6685 42.1568 23.2571 41.1636 22.5247 40.4312C21.7923 39.6989 20.799 39.2875 19.7632 39.2875ZM43.195 39.2855C42.3645 39.2858 41.5557 39.5507 40.8861 40.042C40.2165 40.5332 39.7209 41.225 39.4714 42.0171C39.2218 42.8091 39.2313 43.6601 39.4984 44.4464C39.7655 45.2327 40.2763 45.9134 40.9566 46.3896C41.637 46.8658 42.4515 47.1128 43.2818 47.0946C44.112 47.0764 44.9149 46.794 45.5738 46.2884C46.2326 45.7829 46.7131 45.0804 46.9455 44.2832C47.1779 43.4859 47.15 42.6354 46.866 41.855L46.8328 41.7691C46.5464 41.0376 46.0461 40.4094 45.3971 39.9667C44.7481 39.524 43.9806 39.2872 43.195 39.2875M40.9553 25.62H39.2897V31.4775C39.2897 33.031 38.6725 34.5209 37.574 35.6194C36.4754 36.7178 34.9854 37.335 33.4318 37.335H29.5265C27.9729 37.335 26.4829 36.7178 25.3843 35.6194C24.2857 34.5209 23.6685 33.031 23.6685 31.4775H13.9053V38.0262C14.8442 36.963 16.0548 36.1755 17.4073 35.748C18.7597 35.3205 20.2031 35.2691 21.5825 35.5994C22.9619 35.9297 24.2255 36.6291 25.2376 37.6228C26.2497 38.6165 26.9723 39.8669 27.3278 41.24H35.6305C36.1216 39.3362 37.3129 37.6876 38.9663 36.6235C40.6198 35.5595 42.6137 35.1581 44.5501 35.4996L40.9553 25.62ZM23.6685 23.6675H13.9053V27.5725H23.6685V23.6675ZM45.1477 17.81H39.2897V21.715H45.1477V17.81Z"
        fill="black"
      />
    </svg>
  );
}

export function StorefrontQrCodeIcon() {
  return (
    <svg width="122" height="122" viewBox="0 0 122 122" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 14h34v34H14V14Zm12 12v10h10V26H26ZM74 14h34v34H74V14Zm12 12v10h10V26H86ZM14 74h34v34H14V74Zm12 12v10h10V86H26Z" fill="#000000" />
      <path d="M58 14h10v22H58V14ZM52 52h16v16H52V52ZM74 58h10v10H74V58ZM92 58h16v10H92V58ZM58 74h10v34H58V74ZM74 74h10v10H74V74ZM86 86h10v10H86V86ZM98 98h10v10H98V98ZM74 98h10v10H74V98ZM98 74h10v10H98V74Z" fill="#000000" />
      <path d="M14 58h22v10H14V58ZM52 86h10v10H52V86ZM86 52h22v10H86V52Z" fill="#000000" />
    </svg>
  );
}
